// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"4fa12777","315":"a7ec328a","432":"195fc668","507":"8b70f638","521":"f117ca3b"}[chunkId] + ".chunk.js";
};